let isInitialized = false;
let consentGranted = false;
const queuedEvents = [];

/**
 * Init GA
 * @param {string} token - GA Token
 */
export function initAnalytics(token) {
  if (!token) return;
  const gtmScript = document.createElement('script');
  gtmScript.async = true;
  gtmScript.src = `https://www.googletagmanager.com/gtag/js?id=${token}`;
  document.head.appendChild(gtmScript);

  gtmScript.onload = () => {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', token);
    isInitialized = true;
    if (consentGranted) {
      flushQueuedEvents();
    }
  };
}

/**
 * Send an event to Google Analytics.
 * If gtag has not been initialized, and we haven't received consent, queue it up for later
 * @param {string} name - Event name
 * @param {object} params - Event params
 */
export function trackEvent(name, params = {}) {
  if (consentGranted) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...params });
    console.log("Event tracked: ", name);
  } else {
    queuedEvents.push({ name, params });
  }
}

export function initDefaultConsent() {
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () {
    window.dataLayer.push(arguments);
  };

  window.gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
  });
}

/**
 * Update gtag consent configuration.
 * @param {object} consentConfig - The consent configuration object,
 *   e.g. { analytics_storage: 'granted' }
 */
export function updateGtagConsent(consentConfig) {
  window.gtag('consent', 'update', consentConfig);
}

export function applyConsentChange(decision) {
  if (decision === 'granted') {
    consentGranted = true;
    flushQueuedEvents();
  } else {
    consentGranted = false;
  }
}

function flushQueuedEvents() {
  if (queuedEvents.length === 0) return;
  queuedEvents.forEach(({ name, params }) => {
    trackEvent(name, params);
  });
  queuedEvents.length = 0;
}
